import React from 'react';
import { useRouter } from 'next/router';
import { css } from '@emotion/react';
import { ListArrowNextLightIcon } from 'public/assets';
import theme from '@styles/theme';

const CUSTOM_INFO = {
  storyId: 141,
};

const ChatCustomBanner = () => {
  const router = useRouter();
  const onClickAdEvent = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    router.push({
      pathname: `/story/${CUSTOM_INFO.storyId}`,
      query: {
        section: 'home',
        from: '채팅_배너',
      },
    });
    event.stopPropagation();
  };

  return (
    <div css={container} onClick={onClickAdEvent}>
      <div className="mbti19_banner">
        <button className="mbti19_button">
          <span className="button-text">작품 보러가기</span>
          <ListArrowNextLightIcon
            fill={theme.colors.white}
            width={22}
            height={22}
            className="icon arrow"
          />
        </button>
      </div>
    </div>
  );
};

const container = css`
  padding: 0 1rem 0.75rem;
  cursor: pointer;

  .mbti19_banner {
    position: relative;
    height: 8.5625rem;
    background-image: url('/assets/img_mbti19_banner_pc.png');
    background-repeat: no-repeat;
    background-size: 100% 8.5625rem;

    .mbti19_button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(100% - 2rem);
      position: absolute;
      bottom: 1rem;
      left: 1rem;
      height: 2rem;
      background: ${theme.colors.gray900};
      border-radius: 0.25rem;
      cursor: pointer;
      .icon {
        margin-bottom: 0.25rem;
      }
      .icon.coin {
        margin-left: 0.1875rem;
        margin-bottom: 0.125rem;
      }
      .button-text {
        ${theme.font.header.subhead2}
        color: ${theme.colors.white};
      }
      .button-text.coin {
        color: ${theme.colors.point300};
      }
    }
    @media screen and (max-width: 500px) {
      background-image: url('/assets/img_mbti19_banner_mobile.png');
      background-size: 100% 8.5625rem;
    }
  }
`;

export default ChatCustomBanner;
